import axios from 'axios';
import * as Constants from "../common/constants";
import { AdminMedicineModel } from "../models/medicine";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { MedicineFilterSettings } from "../models/medicine";
import AuthService from './authService';

class MedicineService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllMedicines(from: number, numberOfRows: number, medicineSettings: MedicineFilterSettings) {
		return axios({
			url: `adminMedicine/getAll/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicineSettings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getMedicine(id: number) {
		return axios({
			url: `adminMedicine/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addMedicine(medicine: AdminMedicineModel) {
		return axios({
			url: `adminMedicine/createMedicine`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editMedicine(id: number, medicine: AdminMedicineModel) {
		return axios({
			url: `adminMedicine/updateMedicine/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteMedicine(id: number) {
		return axios({
			url: `adminMedicine/deleteMedicine/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default MedicineService;
